import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import { Property } from "./Editor";
import Input from "./Input";

const String = props => {
  return ___EmotionJSX(Property, {
    name: props.name
  }, ___EmotionJSX(Input, {
    type: "text",
    name: props.name,
    onChange: e => props.onChange(e.target.value),
    value: props.value
  }));
};

export default String;